import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { PaginationContext } from '../../object/pagination_context.model';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styles: []
})
export class PaginationComponent //implements OnChanges
{

  // @Input() currentPage: any = 2
  // @Input() pagesCount: Number = 3
  // @Input() recordsCount: Number = 35
  private defaultContext: PaginationContext = {
    RecordsByPage: 2,
    RecordsCount: 35,
    CurrentPage: 2,
    RequestedPage: 1,
    PagesCount: 3,
  }

  @Input() context: PaginationContext = this.defaultContext

  // @Output() onPrev: EventEmitter<PaginationContext> = new EventEmitter<PaginationContext>()
  // @Output() onNext: EventEmitter<PaginationContext> = new EventEmitter<PaginationContext>()
  @Output() onPageChange: EventEmitter<PaginationContext> = new EventEmitter<PaginationContext>()

  // showPrev: Boolean = false
  // showNext: Boolean = false
  get showPrev(): Boolean {
    return this.context.CurrentPage !== 1
  }
  get showNext(): Boolean {
    return this.context.CurrentPage < this.context.PagesCount
  }


  constructor() {
    this.defaultContext.RecordsByPage = 10
    this.defaultContext.RecordsCount = 0
    this.defaultContext.CurrentPage = 1
    this.defaultContext.RequestedPage = 1
    this.defaultContext.PagesCount = 0

    // this.showPrev = this.context.CurrentPage !== 1
    // this.showNext = this.context.CurrentPage < this.context.PagesCount
  }

  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes.context) {
  //       console.log(changes.context.currentValue);
  //   }
  // }

  goBack() {
    this.pageChange(-1)
  }

  goNext() {
    this.pageChange(1)
  }

  private pageChange(increment: Number) {
    const _context = { ...this.context }
    _context.RequestedPage = _context.CurrentPage + (increment as any)

    this.onPageChange.emit(_context)
  }

}
